import styled, { createGlobalStyle } from 'styled-components'

export const LockScroll = createGlobalStyle`body { overflow: hidden; }`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: ${({ theme }) => theme.colors('shadow', 0.82)};
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  @media (max-width: 480px) {
    align-items: flex-start;
    padding: 0;
    overflow-y: auto;
  }
`

export const Panel = styled.div`
  background: ${({ theme }) => theme.colors('background')};
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.2)};
  box-shadow: 0 0 40px ${({ theme }) => theme.colors('highlight', 0.12)};
  padding: 2rem;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  font-family: 'Silkscreen', monospace;
  color: ${({ theme }) => theme.colors('text')};
  @media (max-width: 480px) {
    max-width: 100%;
    max-height: none;
    min-height: 100dvh;
    padding: 1.25rem 1rem;
    border-left: none;
    border-right: none;
    overflow-y: visible;
  }
`

export const PanelTitle = styled.h2`
  font-size: 1rem;
  letter-spacing: 0.18em;
  color: ${({ theme }) => theme.colors('highlight')};
  margin: 0 0 0.25rem;
  text-transform: uppercase;
`

export const Divider = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors('foreground', 0.12)};
  margin: 1.25rem 0;
`

export const SectionLabel = styled.div`
  font-size: 0.55rem;
  letter-spacing: 0.2em;
  color: ${({ theme }) => theme.colors('foreground', 0.3)};
  margin-bottom: 0.75rem;
  text-transform: uppercase;
`

export const SaveCard = styled.div`
  border: 1px solid ${({ active, theme }) => active ? theme.colors('highlight') : theme.colors('foreground', 0.12)};
  background: ${({ active, theme }) => active ? theme.colors('chrome') : theme.colors('background')};
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  &:hover {
    border-color: ${({ theme }) => theme.colors('highlight', 0.6)};
    background: ${({ theme }) => theme.colors('chrome')};
  }
`

export const SaveInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const SaveName = styled.div`
  font-size: 0.78rem;
  color: ${({ theme }) => theme.colors('text')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SaveMeta = styled.div`
  font-size: 0.58rem;
  color: ${({ theme }) => theme.colors('foreground', 0.45)};
  margin-top: 0.2rem;
`

export const DeleteBtn = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors('danger', 0.6)};
  font-family: 'Silkscreen', monospace;
  font-size: 0.65rem;
  cursor: pointer;
  padding: 0.2rem 0.4rem;
  flex-shrink: 0;
  &:hover { color: ${({ theme }) => theme.colors('danger')}; }
`

export const NewGameBtn = styled.button`
  width: 100%;
  background: none;
  border: 1px dashed ${({ theme }) => theme.colors('foreground', 0.15)};
  color: ${({ theme }) => theme.colors('foreground', 0.45)};
  font-family: 'Silkscreen', monospace;
  font-size: 0.68rem;
  letter-spacing: 0.12em;
  padding: 0.65rem;
  cursor: pointer;
  text-transform: uppercase;
  margin-top: 0.25rem;
  &:hover {
    border-color: ${({ theme }) => theme.colors('highlight')};
    color: ${({ theme }) => theme.colors('highlight')};
  }
`

export const Label = styled.label`
  display: block;
  font-size: 0.58rem;
  letter-spacing: 0.15em;
  color: ${({ theme }) => theme.colors('foreground', 0.3)};
  margin-bottom: 0.4rem;
  text-transform: uppercase;
`

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors('background')};
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.12)};
  color: ${({ theme }) => theme.colors('text')};
  font-family: 'Silkscreen', monospace;
  font-size: 0.78rem;
  padding: 0.55rem 0.75rem;
  outline: none;
  margin-bottom: 1rem;
  &:focus { border-color: ${({ theme }) => theme.colors('highlight')}; }
`

export const ClassGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const ClassCard = styled.button`
  background: ${({ selected, theme }) => selected ? theme.colors('chrome') : theme.colors('background')};
  border: 1px solid ${({ selected, theme }) => selected ? theme.colors('highlight') : theme.colors('foreground', 0.12)};
  color: ${({ selected, theme }) => selected ? theme.colors('text') : theme.colors('foreground', 0.45)};
  font-family: 'Silkscreen', monospace;
  padding: 0.65rem 0.5rem;
  cursor: pointer;
  text-align: left;
  &:hover {
    border-color: ${({ theme }) => theme.colors('highlight', 0.6)};
    color: ${({ theme }) => theme.colors('text')};
  }
`

export const ClassName = styled.div`
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  margin-bottom: 0.25rem;
`

export const ClassDesc = styled.div`
  font-size: 0.52rem;
  color: ${({ theme }) => theme.colors('foreground', 0.3)};
  line-height: 1.3;
`

export const SpritePreview = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  & img {
    width: 128px;
    height: 128px;
    @media (max-width: 480px) {
      width: 80px;
      height: 80px;
    }
  }
`

export const Actions = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
`

export const Btn = styled.button`
  flex: 1;
  background: ${({ primary, theme }) => primary ? theme.colors('chrome') : 'none'};
  border: 1px solid ${({ primary, theme }) => primary ? theme.colors('highlight') : theme.colors('foreground', 0.15)};
  color: ${({ primary, theme }) => primary ? theme.colors('text') : theme.colors('foreground', 0.45)};
  font-family: 'Silkscreen', monospace;
  font-size: 0.7rem;
  letter-spacing: 0.1em;
  padding: 0.55rem 1rem;
  cursor: pointer;
  text-transform: uppercase;
  &:hover {
    background: ${({ theme }) => theme.colors('chrome')};
    border-color: ${({ theme }) => theme.colors('highlight')};
    color: ${({ theme }) => theme.colors('text')};
  }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`

export const ErrorMsg = styled.div`
  font-size: 0.62rem;
  color: ${({ theme }) => theme.colors('danger')};
  margin-top: 0.75rem;
`
